//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class UseHttpCookiesForApi {
    protected transformOptions(options: RequestInit): Promise<RequestInit> {
        options.credentials = 'include';
        return Promise.resolve(options);
    }
}

export class ApiClient extends UseHttpCookiesForApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getApplicationVersion(signal?: AbortSignal): Promise<ApplicationVersionResponse> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplicationVersion(_response);
        });
    }

    protected processGetApplicationVersion(response: Response): Promise<ApplicationVersionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationVersionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationVersionResponse>(null as any);
    }

    /**
     * @param returnUrl (optional) 
     * @param screenHint (optional) 
     * @return OK
     */
    login(returnUrl: string | undefined, screenHint: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/auth/login?";
        if (returnUrl === null)
            throw new globalThis.Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (screenHint === null)
            throw new globalThis.Error("The parameter 'screenHint' cannot be null.");
        else if (screenHint !== undefined)
            url_ += "screenHint=" + encodeURIComponent("" + screenHint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentUser(signal?: AbortSignal): Promise<UserAccountResponse> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: Response): Promise<UserAccountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccountResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAccountResponse>(null as any);
    }

    /**
     * @return OK
     */
    updateUserSettings(body: UpdateUserSettingsRequest, signal?: AbortSignal): Promise<UserAccountResponse> {
        let url_ = this.baseUrl + "/api/users/me/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserSettings(_response);
        });
    }

    protected processUpdateUserSettings(response: Response): Promise<UserAccountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAccountResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAccountResponse>(null as any);
    }

    /**
     * @return OK
     */
    getSupportedLanguages(signal?: AbortSignal): Promise<SupportedLanguage[]> {
        let url_ = this.baseUrl + "/api/users/languages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSupportedLanguages(_response);
        });
    }

    protected processGetSupportedLanguages(response: Response): Promise<SupportedLanguage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupportedLanguage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupportedLanguage[]>(null as any);
    }

    /**
     * @param cursor (optional) 
     * @param tagId (optional) 
     * @param search (optional) 
     * @param kind (optional) 
     * @return OK
     */
    getMeaning(limit: number, cursor: string | undefined, tagId: string | undefined, search: string | undefined, kind: MeaningKind | null | undefined, signal?: AbortSignal): Promise<GetMeaningPageResponse> {
        let url_ = this.baseUrl + "/api/meaning?";
        if (limit === undefined || limit === null)
            throw new globalThis.Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (cursor === null)
            throw new globalThis.Error("The parameter 'cursor' cannot be null.");
        else if (cursor !== undefined)
            url_ += "Cursor=" + encodeURIComponent("" + cursor) + "&";
        if (tagId === null)
            throw new globalThis.Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "TagId=" + encodeURIComponent("" + tagId) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (kind !== undefined && kind !== null)
            url_ += "Kind=" + encodeURIComponent("" + kind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeaning(_response);
        });
    }

    protected processGetMeaning(response: Response): Promise<GetMeaningPageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMeaningPageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMeaningPageResponse>(null as any);
    }

    /**
     * @return OK
     */
    postMeaning(body: MeaningCreationRequest, signal?: AbortSignal): Promise<MeaningCreationResponse> {
        let url_ = this.baseUrl + "/api/meaning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostMeaning(_response);
        });
    }

    protected processPostMeaning(response: Response): Promise<MeaningCreationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeaningCreationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningCreationResponse>(null as any);
    }

    /**
     * @param q (optional) 
     * @return OK
     */
    getMeaningSuggestions(q: string | undefined, limit: number, signal?: AbortSignal): Promise<MeaningSuggestionDto[]> {
        let url_ = this.baseUrl + "/api/meaning/suggest?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "Q=" + encodeURIComponent("" + q) + "&";
        if (limit === undefined || limit === null)
            throw new globalThis.Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeaningSuggestions(_response);
        });
    }

    protected processGetMeaningSuggestions(response: Response): Promise<MeaningSuggestionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeaningSuggestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningSuggestionDto[]>(null as any);
    }

    /**
     * @return OK
     */
    postMeaningManual(body: ManualMeaningCreationRequest, signal?: AbortSignal): Promise<MeaningCreationResponse> {
        let url_ = this.baseUrl + "/api/meaning/manual";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostMeaningManual(_response);
        });
    }

    protected processPostMeaningManual(response: Response): Promise<MeaningCreationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeaningCreationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningCreationResponse>(null as any);
    }

    /**
     * @return OK
     */
    getMeaningById(id: string, signal?: AbortSignal): Promise<MeaningDto> {
        let url_ = this.baseUrl + "/api/meaning/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeaningById(_response);
        });
    }

    protected processGetMeaningById(response: Response): Promise<MeaningDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeaningDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningDto>(null as any);
    }

    /**
     * @return OK
     */
    putMeaning(id: string, body: MeaningRequest, signal?: AbortSignal): Promise<MeaningDto> {
        let url_ = this.baseUrl + "/api/meaning/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutMeaning(_response);
        });
    }

    protected processPutMeaning(response: Response): Promise<MeaningDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeaningDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningDto>(null as any);
    }

    /**
     * @return No Content
     */
    deleteMeaning(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/meaning/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMeaning(_response);
        });
    }

    protected processDeleteMeaning(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getMeaningCollocations(id: string, signal?: AbortSignal): Promise<CollocationDto[]> {
        let url_ = this.baseUrl + "/api/meaning/{id}/collocations";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeaningCollocations(_response);
        });
    }

    protected processGetMeaningCollocations(response: Response): Promise<CollocationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollocationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollocationDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getMeaningPronunciation(id: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/meaning/{id}/pronunciation";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "audio/mpeg"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeaningPronunciation(_response);
        });
    }

    protected processGetMeaningPronunciation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("Service Unavailable", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return OK
     */
    chatWithMeaningCard(id: string, body: CardChatRequest, signal?: AbortSignal): Promise<SseItemOfCardChatEvent> {
        let url_ = this.baseUrl + "/api/meaning/{id}/chat";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/event-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChatWithMeaningCard(_response);
        });
    }

    protected processChatWithMeaningCard(response: Response): Promise<SseItemOfCardChatEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SseItemOfCardChatEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SseItemOfCardChatEvent>(null as any);
    }

    /**
     * @return OK
     */
    getCardChat(id: string, signal?: AbortSignal): Promise<CardChatHistoryResponse> {
        let url_ = this.baseUrl + "/api/meaning/{id}/chat";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCardChat(_response);
        });
    }

    protected processGetCardChat(response: Response): Promise<CardChatHistoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardChatHistoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardChatHistoryResponse>(null as any);
    }

    /**
     * @return No Content
     */
    resetCardChat(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/meaning/{id}/chat";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetCardChat(_response);
        });
    }

    protected processResetCardChat(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    regenerateMeaning(id: string, signal?: AbortSignal): Promise<MeaningDto> {
        let url_ = this.baseUrl + "/api/meaning/{id}/regenerate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegenerateMeaning(_response);
        });
    }

    protected processRegenerateMeaning(response: Response): Promise<MeaningDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeaningDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningDto>(null as any);
    }

    /**
     * @return OK
     */
    pinMeaningExample(id: string, body: PinMeaningExampleRequest, signal?: AbortSignal): Promise<PinMeaningExampleResponse> {
        let url_ = this.baseUrl + "/api/meaning/{id}/examples/pin";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPinMeaningExample(_response);
        });
    }

    protected processPinMeaningExample(response: Response): Promise<PinMeaningExampleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PinMeaningExampleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PinMeaningExampleResponse>(null as any);
    }

    /**
     * @return OK
     */
    regenerateMeaningExamples(id: string, signal?: AbortSignal): Promise<ExampleDto[]> {
        let url_ = this.baseUrl + "/api/meaning/{id}/examples/regenerate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegenerateMeaningExamples(_response);
        });
    }

    protected processRegenerateMeaningExamples(response: Response): Promise<ExampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExampleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExampleDto[]>(null as any);
    }

    /**
     * @param checkSense (optional) 
     * @return OK
     */
    searchCardNews(id: string, checkSense: boolean | undefined, body: CorpusSearchRequest, signal?: AbortSignal): Promise<CardNewsSearchPageResponse> {
        let url_ = this.baseUrl + "/api/meaning/{id}/news/search?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (checkSense === null)
            throw new globalThis.Error("The parameter 'checkSense' cannot be null.");
        else if (checkSense !== undefined)
            url_ += "checkSense=" + encodeURIComponent("" + checkSense) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCardNews(_response);
        });
    }

    protected processSearchCardNews(response: Response): Promise<CardNewsSearchPageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardNewsSearchPageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CardNewsSearchPageResponse>(null as any);
    }

    /**
     * @return OK
     */
    generateMeaningAlternatives(id: string, signal?: AbortSignal): Promise<MeaningAlternativeDto[]> {
        let url_ = this.baseUrl + "/api/meaning/{id}/alternatives";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateMeaningAlternatives(_response);
        });
    }

    protected processGenerateMeaningAlternatives(response: Response): Promise<MeaningAlternativeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeaningAlternativeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningAlternativeDto[]>(null as any);
    }

    /**
     * @return OK
     */
    getMeaningTags(signal?: AbortSignal): Promise<MeaningTagDto[]> {
        let url_ = this.baseUrl + "/api/meaning/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeaningTags(_response);
        });
    }

    protected processGetMeaningTags(response: Response): Promise<MeaningTagDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeaningTagDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningTagDto[]>(null as any);
    }

    /**
     * @return Created
     */
    createMeaningTag(body: CreateMeaningTagRequest, signal?: AbortSignal): Promise<MeaningTagDto> {
        let url_ = this.baseUrl + "/api/meaning/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMeaningTag(_response);
        });
    }

    protected processCreateMeaningTag(response: Response): Promise<MeaningTagDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MeaningTagDto.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningTagDto>(null as any);
    }

    /**
     * @return OK
     */
    replaceMeaningTags(id: string, body: ReplaceMeaningTagsRequest, signal?: AbortSignal): Promise<MeaningTagDto[]> {
        let url_ = this.baseUrl + "/api/meaning/{id}/tags";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReplaceMeaningTags(_response);
        });
    }

    protected processReplaceMeaningTags(response: Response): Promise<MeaningTagDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeaningTagDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeaningTagDto[]>(null as any);
    }

    /**
     * @return No Content
     */
    deleteMeaningTag(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/meaning/tags/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMeaningTag(_response);
        });
    }

    protected processDeleteMeaningTag(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getWeeklyStatistics(timeZone: string, signal?: AbortSignal): Promise<WeeklyStatisticsResponse> {
        let url_ = this.baseUrl + "/api/statistics/week?";
        if (timeZone === undefined || timeZone === null)
            throw new globalThis.Error("The parameter 'timeZone' must be defined and cannot be null.");
        else
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWeeklyStatistics(_response);
        });
    }

    protected processGetWeeklyStatistics(response: Response): Promise<WeeklyStatisticsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeeklyStatisticsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WeeklyStatisticsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getTagStatistics(signal?: AbortSignal): Promise<TagStatisticsResponse> {
        let url_ = this.baseUrl + "/api/statistics/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTagStatistics(_response);
        });
    }

    protected processGetTagStatistics(response: Response): Promise<TagStatisticsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagStatisticsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TagStatisticsResponse>(null as any);
    }

    /**
     * @return OK
     */
    getTrainingCards(limit: number, signal?: AbortSignal): Promise<TrainingCardsResponse> {
        let url_ = this.baseUrl + "/api/training?";
        if (limit === undefined || limit === null)
            throw new globalThis.Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingCards(_response);
        });
    }

    protected processGetTrainingCards(response: Response): Promise<TrainingCardsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCardsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingCardsResponse>(null as any);
    }

    /**
     * @return OK
     */
    reviewTrainingCard(cardId: string, body: TrainingReviewRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/training/{cardId}";
        if (cardId === undefined || cardId === null)
            throw new globalThis.Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReviewTrainingCard(_response);
        });
    }

    protected processReviewTrainingCard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param cursor (optional) 
     * @param meaningId (optional) 
     * @return OK
     */
    getFeed(limit: number, cursor: string | undefined, meaningId: string | undefined, signal?: AbortSignal): Promise<GetFeedPageResponse> {
        let url_ = this.baseUrl + "/api/feed?";
        if (limit === undefined || limit === null)
            throw new globalThis.Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (cursor === null)
            throw new globalThis.Error("The parameter 'cursor' cannot be null.");
        else if (cursor !== undefined)
            url_ += "Cursor=" + encodeURIComponent("" + cursor) + "&";
        if (meaningId === null)
            throw new globalThis.Error("The parameter 'meaningId' cannot be null.");
        else if (meaningId !== undefined)
            url_ += "MeaningId=" + encodeURIComponent("" + meaningId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFeed(_response);
        });
    }

    protected processGetFeed(response: Response): Promise<GetFeedPageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFeedPageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFeedPageResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLiveFeed(signal?: AbortSignal): Promise<LiveFeedResponse> {
        let url_ = this.baseUrl + "/api/feed/live";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLiveFeed(_response);
        });
    }

    protected processGetLiveFeed(response: Response): Promise<LiveFeedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LiveFeedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LiveFeedResponse>(null as any);
    }

    /**
     * @return OK
     */
    searchCorpusNews(body: CorpusSearchRequest, signal?: AbortSignal): Promise<NewsSearchPageResponse> {
        let url_ = this.baseUrl + "/api/corpus/news/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCorpusNews(_response);
        });
    }

    protected processSearchCorpusNews(response: Response): Promise<NewsSearchPageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsSearchPageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewsSearchPageResponse>(null as any);
    }

    /**
     * @return OK
     */
    claimYoutubeCaptionJobs(signal?: AbortSignal): Promise<YoutubeCaptionJobClaimResponse[]> {
        let url_ = this.baseUrl + "/api/internal/youtube/jobs/claim";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClaimYoutubeCaptionJobs(_response);
        });
    }

    protected processClaimYoutubeCaptionJobs(response: Response): Promise<YoutubeCaptionJobClaimResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(YoutubeCaptionJobClaimResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<YoutubeCaptionJobClaimResponse[]>(null as any);
    }

    /**
     * @return No Content
     */
    completeYoutubeCaptionJob(jobId: number, body: YoutubeCaptionJobCompleteRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/youtube/jobs/{jobId}/complete";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteYoutubeCaptionJob(_response);
        });
    }

    protected processCompleteYoutubeCaptionJob(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    failYoutubeCaptionJob(jobId: number, body: YoutubeCaptionJobFailureRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/internal/youtube/jobs/{jobId}/fail";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFailYoutubeCaptionJob(_response);
        });
    }

    protected processFailYoutubeCaptionJob(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Conflict", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    searchCorpusVideo(body: CorpusSearchRequest, signal?: AbortSignal): Promise<YoutubeSearchPageResponse> {
        let url_ = this.baseUrl + "/api/corpus/video/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCorpusVideo(_response);
        });
    }

    protected processSearchCorpusVideo(response: Response): Promise<YoutubeSearchPageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = YoutubeSearchPageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<YoutubeSearchPageResponse>(null as any);
    }

    /**
     * @return OK
     */
    searchCorpusVideoText(body: VideoTextSearchRequest, signal?: AbortSignal): Promise<YoutubeSearchPageResponse> {
        let url_ = this.baseUrl + "/api/corpus/video/search-text";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCorpusVideoText(_response);
        });
    }

    protected processSearchCorpusVideoText(response: Response): Promise<YoutubeSearchPageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = YoutubeSearchPageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<YoutubeSearchPageResponse>(null as any);
    }

    /**
     * @return OK
     */
    getYoutubeCaptions(videoId: string, signal?: AbortSignal): Promise<YoutubeCaptionTrackResponse> {
        let url_ = this.baseUrl + "/api/youtube/videos/{videoId}/captions";
        if (videoId === undefined || videoId === null)
            throw new globalThis.Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetYoutubeCaptions(_response);
        });
    }

    protected processGetYoutubeCaptions(response: Response): Promise<YoutubeCaptionTrackResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = YoutubeCaptionTrackResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<YoutubeCaptionTrackResponse>(null as any);
    }
}

export class ApplicationVersionResponse implements IApplicationVersionResponse {
    version!: string;
    informationalVersion!: string;
    serviceV2Enabled!: boolean;

    [key: string]: any;

    constructor(data?: IApplicationVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.version = _data["version"];
            this.informationalVersion = _data["informationalVersion"];
            this.serviceV2Enabled = _data["serviceV2Enabled"];
        }
    }

    static fromJS(data: any): ApplicationVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["version"] = this.version;
        data["informationalVersion"] = this.informationalVersion;
        data["serviceV2Enabled"] = this.serviceV2Enabled;
        return data;
    }
}

export interface IApplicationVersionResponse {
    version: string;
    informationalVersion: string;
    serviceV2Enabled: boolean;

    [key: string]: any;
}

export class CardChatEvent implements ICardChatEvent {
    text?: string | undefined;
    message?: string | undefined;
    examples?: CardChatExamples | undefined;

    [key: string]: any;

    constructor(data?: ICardChatEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            this.message = _data["message"];
            this.examples = _data["examples"] ? CardChatExamples.fromJS(_data["examples"]) : undefined as any;
        }
    }

    static fromJS(data: any): CardChatEvent {
        data = typeof data === 'object' ? data : {};
        let result = new CardChatEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        data["message"] = this.message;
        data["examples"] = this.examples ? this.examples.toJSON() : undefined as any;
        return data;
    }
}

export interface ICardChatEvent {
    text?: string | undefined;
    message?: string | undefined;
    examples?: CardChatExamples | undefined;

    [key: string]: any;
}

export class CardChatExamples implements ICardChatExamples {
    query!: string;
    news!: NewsSearchItemDto[];
    videos!: YoutubeSearchItemDto[];

    [key: string]: any;

    constructor(data?: ICardChatExamples) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.news = [];
            this.videos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.query = _data["query"];
            if (Array.isArray(_data["news"])) {
                this.news = [] as any;
                for (let item of _data["news"])
                    this.news!.push(NewsSearchItemDto.fromJS(item));
            }
            if (Array.isArray(_data["videos"])) {
                this.videos = [] as any;
                for (let item of _data["videos"])
                    this.videos!.push(YoutubeSearchItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardChatExamples {
        data = typeof data === 'object' ? data : {};
        let result = new CardChatExamples();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["query"] = this.query;
        if (Array.isArray(this.news)) {
            data["news"] = [];
            for (let item of this.news)
                data["news"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICardChatExamples {
    query: string;
    news: NewsSearchItemDto[];
    videos: YoutubeSearchItemDto[];

    [key: string]: any;
}

export class CardChatHistoryMessage implements ICardChatHistoryMessage {
    role!: string;
    text!: string;
    examples!: CardChatExamples[];

    [key: string]: any;

    constructor(data?: ICardChatHistoryMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.examples = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.role = _data["role"];
            this.text = _data["text"];
            if (Array.isArray(_data["examples"])) {
                this.examples = [] as any;
                for (let item of _data["examples"])
                    this.examples!.push(CardChatExamples.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardChatHistoryMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CardChatHistoryMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["role"] = this.role;
        data["text"] = this.text;
        if (Array.isArray(this.examples)) {
            data["examples"] = [];
            for (let item of this.examples)
                data["examples"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICardChatHistoryMessage {
    role: string;
    text: string;
    examples: CardChatExamples[];

    [key: string]: any;
}

export class CardChatHistoryResponse implements ICardChatHistoryResponse {
    messages!: CardChatHistoryMessage[];

    [key: string]: any;

    constructor(data?: ICardChatHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.messages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(CardChatHistoryMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CardChatHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CardChatHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICardChatHistoryResponse {
    messages: CardChatHistoryMessage[];

    [key: string]: any;
}

export class CardChatRequest implements ICardChatRequest {
    message?: string;

    [key: string]: any;

    constructor(data?: ICardChatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CardChatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CardChatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface ICardChatRequest {
    message?: string;

    [key: string]: any;
}

export class CardNewsSearchItemDto implements ICardNewsSearchItemDto {
    example!: NewsSearchItemDto;
    senseProbability!: number | undefined;
    senseConfirmed!: boolean | undefined;

    [key: string]: any;

    constructor(data?: ICardNewsSearchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.example = new NewsSearchItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.example = _data["example"] ? NewsSearchItemDto.fromJS(_data["example"]) : new NewsSearchItemDto();
            this.senseProbability = _data["senseProbability"];
            this.senseConfirmed = _data["senseConfirmed"];
        }
    }

    static fromJS(data: any): CardNewsSearchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardNewsSearchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["example"] = this.example ? this.example.toJSON() : undefined as any;
        data["senseProbability"] = this.senseProbability;
        data["senseConfirmed"] = this.senseConfirmed;
        return data;
    }
}

export interface ICardNewsSearchItemDto {
    example: NewsSearchItemDto;
    senseProbability: number | undefined;
    senseConfirmed: boolean | undefined;

    [key: string]: any;
}

export class CardNewsSearchPageResponse implements ICardNewsSearchPageResponse {
    items!: CardNewsSearchItemDto[];
    nextCursor!: string | undefined;
    hasMore!: boolean;

    [key: string]: any;

    constructor(data?: ICardNewsSearchPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CardNewsSearchItemDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): CardNewsSearchPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CardNewsSearchPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface ICardNewsSearchPageResponse {
    items: CardNewsSearchItemDto[];
    nextCursor: string | undefined;
    hasMore: boolean;

    [key: string]: any;
}

export class CollocationDto implements ICollocationDto {
    pattern?: string;
    role?: string;
    partner?: string;
    logDice?: number;
    frequency?: number;

    [key: string]: any;

    constructor(data?: ICollocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pattern = _data["pattern"];
            this.role = _data["role"];
            this.partner = _data["partner"];
            this.logDice = _data["logDice"];
            this.frequency = _data["frequency"];
        }
    }

    static fromJS(data: any): CollocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pattern"] = this.pattern;
        data["role"] = this.role;
        data["partner"] = this.partner;
        data["logDice"] = this.logDice;
        data["frequency"] = this.frequency;
        return data;
    }
}

export interface ICollocationDto {
    pattern?: string;
    role?: string;
    partner?: string;
    logDice?: number;
    frequency?: number;

    [key: string]: any;
}

export class CorpusSearchRequest implements ICorpusSearchRequest {
    phrase?: PhraseTokenDto[] | undefined;
    words?: string[] | undefined;
    anyWords?: string[] | undefined;
    posOverrides?: string[] | undefined;
    limit?: number;
    cursor?: string | undefined;

    [key: string]: any;

    constructor(data?: ICorpusSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["phrase"])) {
                this.phrase = [] as any;
                for (let item of _data["phrase"])
                    this.phrase!.push(PhraseTokenDto.fromJS(item));
            }
            if (Array.isArray(_data["words"])) {
                this.words = [] as any;
                for (let item of _data["words"])
                    this.words!.push(item);
            }
            if (Array.isArray(_data["anyWords"])) {
                this.anyWords = [] as any;
                for (let item of _data["anyWords"])
                    this.anyWords!.push(item);
            }
            if (Array.isArray(_data["posOverrides"])) {
                this.posOverrides = [] as any;
                for (let item of _data["posOverrides"])
                    this.posOverrides!.push(item);
            }
            this.limit = _data["limit"];
            this.cursor = _data["cursor"];
        }
    }

    static fromJS(data: any): CorpusSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CorpusSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.phrase)) {
            data["phrase"] = [];
            for (let item of this.phrase)
                data["phrase"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.words)) {
            data["words"] = [];
            for (let item of this.words)
                data["words"].push(item);
        }
        if (Array.isArray(this.anyWords)) {
            data["anyWords"] = [];
            for (let item of this.anyWords)
                data["anyWords"].push(item);
        }
        if (Array.isArray(this.posOverrides)) {
            data["posOverrides"] = [];
            for (let item of this.posOverrides)
                data["posOverrides"].push(item);
        }
        data["limit"] = this.limit;
        data["cursor"] = this.cursor;
        return data;
    }
}

export interface ICorpusSearchRequest {
    phrase?: PhraseTokenDto[] | undefined;
    words?: string[] | undefined;
    anyWords?: string[] | undefined;
    posOverrides?: string[] | undefined;
    limit?: number;
    cursor?: string | undefined;

    [key: string]: any;
}

export class CreateMeaningTagRequest implements ICreateMeaningTagRequest {
    name!: string | undefined;

    [key: string]: any;

    constructor(data?: ICreateMeaningTagRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateMeaningTagRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeaningTagRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateMeaningTagRequest {
    name: string | undefined;

    [key: string]: any;
}

export class DailyNewCardsResponse implements IDailyNewCardsResponse {
    date!: Date;
    count!: number;

    [key: string]: any;

    constructor(data?: IDailyNewCardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): DailyNewCardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DailyNewCardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["date"] = this.date ? formatDate(this.date) : undefined as any;
        data["count"] = this.count;
        return data;
    }
}

export interface IDailyNewCardsResponse {
    date: Date;
    count: number;

    [key: string]: any;
}

export class ExampleDto implements IExampleDto {
    text?: string | undefined;
    translation?: string | undefined;
    pinned?: boolean;

    [key: string]: any;

    constructor(data?: IExampleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            this.translation = _data["translation"];
            this.pinned = _data["pinned"];
        }
    }

    static fromJS(data: any): ExampleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExampleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        data["translation"] = this.translation;
        data["pinned"] = this.pinned;
        return data;
    }
}

export interface IExampleDto {
    text?: string | undefined;
    translation?: string | undefined;
    pinned?: boolean;

    [key: string]: any;
}

export class FeedHighlightSpan implements IFeedHighlightSpan {
    start!: number;
    end!: number;

    [key: string]: any;

    constructor(data?: IFeedHighlightSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): FeedHighlightSpan {
        data = typeof data === 'object' ? data : {};
        let result = new FeedHighlightSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["start"] = this.start;
        data["end"] = this.end;
        return data;
    }
}

export interface IFeedHighlightSpan {
    start: number;
    end: number;

    [key: string]: any;
}

export class FeedItemDto implements IFeedItemDto {
    matchId!: string;
    meaningId!: string;
    phraseText!: string;
    sentence!: string;
    matchedTokens!: FeedHighlightSpan[];
    articleUrl!: string;
    articleTitle!: string | undefined;
    articleDomain!: string;
    siteName!: string | undefined;
    logoUrl!: string | undefined;
    publishedAtUtc!: Date | undefined;
    createdAtUtc!: Date;
    segmentId!: number;

    [key: string]: any;

    constructor(data?: IFeedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.matchedTokens = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.matchId = _data["matchId"];
            this.meaningId = _data["meaningId"];
            this.phraseText = _data["phraseText"];
            this.sentence = _data["sentence"];
            if (Array.isArray(_data["matchedTokens"])) {
                this.matchedTokens = [] as any;
                for (let item of _data["matchedTokens"])
                    this.matchedTokens!.push(FeedHighlightSpan.fromJS(item));
            }
            this.articleUrl = _data["articleUrl"];
            this.articleTitle = _data["articleTitle"];
            this.articleDomain = _data["articleDomain"];
            this.siteName = _data["siteName"];
            this.logoUrl = _data["logoUrl"];
            this.publishedAtUtc = _data["publishedAtUtc"] ? new Date(_data["publishedAtUtc"].toString()) : undefined as any;
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.segmentId = _data["segmentId"];
        }
    }

    static fromJS(data: any): FeedItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["matchId"] = this.matchId;
        data["meaningId"] = this.meaningId;
        data["phraseText"] = this.phraseText;
        data["sentence"] = this.sentence;
        if (Array.isArray(this.matchedTokens)) {
            data["matchedTokens"] = [];
            for (let item of this.matchedTokens)
                data["matchedTokens"].push(item ? item.toJSON() : undefined as any);
        }
        data["articleUrl"] = this.articleUrl;
        data["articleTitle"] = this.articleTitle;
        data["articleDomain"] = this.articleDomain;
        data["siteName"] = this.siteName;
        data["logoUrl"] = this.logoUrl;
        data["publishedAtUtc"] = this.publishedAtUtc ? this.publishedAtUtc.toISOString() : undefined as any;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["segmentId"] = this.segmentId;
        return data;
    }
}

export interface IFeedItemDto {
    matchId: string;
    meaningId: string;
    phraseText: string;
    sentence: string;
    matchedTokens: FeedHighlightSpan[];
    articleUrl: string;
    articleTitle: string | undefined;
    articleDomain: string;
    siteName: string | undefined;
    logoUrl: string | undefined;
    publishedAtUtc: Date | undefined;
    createdAtUtc: Date;
    segmentId: number;

    [key: string]: any;
}

export class GetFeedPageResponse implements IGetFeedPageResponse {
    items!: FeedItemDto[];
    nextCursor!: string | undefined;
    nextLink!: string | undefined;
    hasMore!: boolean;
    phraseChips!: PhraseChipDto[];

    [key: string]: any;

    constructor(data?: IGetFeedPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.phraseChips = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeedItemDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
            this.nextLink = _data["nextLink"];
            this.hasMore = _data["hasMore"];
            if (Array.isArray(_data["phraseChips"])) {
                this.phraseChips = [] as any;
                for (let item of _data["phraseChips"])
                    this.phraseChips!.push(PhraseChipDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFeedPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFeedPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor;
        data["nextLink"] = this.nextLink;
        data["hasMore"] = this.hasMore;
        if (Array.isArray(this.phraseChips)) {
            data["phraseChips"] = [];
            for (let item of this.phraseChips)
                data["phraseChips"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetFeedPageResponse {
    items: FeedItemDto[];
    nextCursor: string | undefined;
    nextLink: string | undefined;
    hasMore: boolean;
    phraseChips: PhraseChipDto[];

    [key: string]: any;
}

export class GetMeaningPageResponse implements IGetMeaningPageResponse {
    items!: MeaningDto[];
    nextCursor!: string | undefined;
    nextLink!: string | undefined;
    hasMore!: boolean;

    [key: string]: any;

    constructor(data?: IGetMeaningPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MeaningDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
            this.nextLink = _data["nextLink"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): GetMeaningPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMeaningPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor;
        data["nextLink"] = this.nextLink;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IGetMeaningPageResponse {
    items: MeaningDto[];
    nextCursor: string | undefined;
    nextLink: string | undefined;
    hasMore: boolean;

    [key: string]: any;
}

export class HttpValidationProblemDetails implements IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IHttpValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export class LiveFeedResponse implements ILiveFeedResponse {
    items!: FeedItemDto[];

    [key: string]: any;

    constructor(data?: ILiveFeedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FeedItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LiveFeedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LiveFeedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILiveFeedResponse {
    items: FeedItemDto[];

    [key: string]: any;
}

export class ManualMeaningCreationRequest implements IManualMeaningCreationRequest {
    textInput?: string;
    translation?: string | undefined;
    definition?: string | undefined;

    [key: string]: any;

    constructor(data?: IManualMeaningCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.textInput = _data["textInput"];
            this.translation = _data["translation"];
            this.definition = _data["definition"];
        }
    }

    static fromJS(data: any): ManualMeaningCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ManualMeaningCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["textInput"] = this.textInput;
        data["translation"] = this.translation;
        data["definition"] = this.definition;
        return data;
    }
}

export interface IManualMeaningCreationRequest {
    textInput?: string;
    translation?: string | undefined;
    definition?: string | undefined;

    [key: string]: any;
}

export class MeaningAlternativeDto implements IMeaningAlternativeDto {
    alternative?: string;
    score?: number | undefined;

    [key: string]: any;

    constructor(data?: IMeaningAlternativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.alternative = _data["alternative"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): MeaningAlternativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeaningAlternativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["alternative"] = this.alternative;
        data["score"] = this.score;
        return data;
    }
}

export interface IMeaningAlternativeDto {
    alternative?: string;
    score?: number | undefined;

    [key: string]: any;
}

export class MeaningContentDto implements IMeaningContentDto {
    kind?: string;
    canonical?: string | undefined;
    displayedText?: string | undefined;
    sound?: string | undefined;
    dictionaryForm?: string | undefined;
    translation?: string | undefined;
    textInput?: string;
    selections?: SelectionRange[];
    phraseChips?: PhraseChipDto[];
    phraseTokens?: PhraseTokenDto[];
    definition?: string | undefined;
    translations?: string[];
    examples?: ExampleDto[];
    alternatives?: MeaningAlternativeDto[];
    alternativesPending?: boolean;
    isSlotted?: boolean;

    [key: string]: any;

    constructor(data?: IMeaningContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.kind = _data["kind"];
            this.canonical = _data["canonical"];
            this.displayedText = _data["displayedText"];
            this.sound = _data["sound"];
            this.dictionaryForm = _data["dictionaryForm"];
            this.translation = _data["translation"];
            this.textInput = _data["textInput"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections!.push(SelectionRange.fromJS(item));
            }
            if (Array.isArray(_data["phraseChips"])) {
                this.phraseChips = [] as any;
                for (let item of _data["phraseChips"])
                    this.phraseChips!.push(PhraseChipDto.fromJS(item));
            }
            if (Array.isArray(_data["phraseTokens"])) {
                this.phraseTokens = [] as any;
                for (let item of _data["phraseTokens"])
                    this.phraseTokens!.push(PhraseTokenDto.fromJS(item));
            }
            this.definition = _data["definition"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(item);
            }
            if (Array.isArray(_data["examples"])) {
                this.examples = [] as any;
                for (let item of _data["examples"])
                    this.examples!.push(ExampleDto.fromJS(item));
            }
            if (Array.isArray(_data["alternatives"])) {
                this.alternatives = [] as any;
                for (let item of _data["alternatives"])
                    this.alternatives!.push(MeaningAlternativeDto.fromJS(item));
            }
            this.alternativesPending = _data["alternativesPending"];
            this.isSlotted = _data["isSlotted"];
        }
    }

    static fromJS(data: any): MeaningContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeaningContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["kind"] = this.kind;
        data["canonical"] = this.canonical;
        data["displayedText"] = this.displayedText;
        data["sound"] = this.sound;
        data["dictionaryForm"] = this.dictionaryForm;
        data["translation"] = this.translation;
        data["textInput"] = this.textInput;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phraseChips)) {
            data["phraseChips"] = [];
            for (let item of this.phraseChips)
                data["phraseChips"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.phraseTokens)) {
            data["phraseTokens"] = [];
            for (let item of this.phraseTokens)
                data["phraseTokens"].push(item ? item.toJSON() : undefined as any);
        }
        data["definition"] = this.definition;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item);
        }
        if (Array.isArray(this.examples)) {
            data["examples"] = [];
            for (let item of this.examples)
                data["examples"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.alternatives)) {
            data["alternatives"] = [];
            for (let item of this.alternatives)
                data["alternatives"].push(item ? item.toJSON() : undefined as any);
        }
        data["alternativesPending"] = this.alternativesPending;
        data["isSlotted"] = this.isSlotted;
        return data;
    }
}

export interface IMeaningContentDto {
    kind?: string;
    canonical?: string | undefined;
    displayedText?: string | undefined;
    sound?: string | undefined;
    dictionaryForm?: string | undefined;
    translation?: string | undefined;
    textInput?: string;
    selections?: SelectionRange[];
    phraseChips?: PhraseChipDto[];
    phraseTokens?: PhraseTokenDto[];
    definition?: string | undefined;
    translations?: string[];
    examples?: ExampleDto[];
    alternatives?: MeaningAlternativeDto[];
    alternativesPending?: boolean;
    isSlotted?: boolean;

    [key: string]: any;
}

export class MeaningCreationRequest implements IMeaningCreationRequest {
    textInput?: string;
    selections?: SelectionRange[];

    [key: string]: any;

    constructor(data?: IMeaningCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.textInput = _data["textInput"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections!.push(SelectionRange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeaningCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MeaningCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["textInput"] = this.textInput;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeaningCreationRequest {
    textInput?: string;
    selections?: SelectionRange[];

    [key: string]: any;
}

export class MeaningCreationResponse implements IMeaningCreationResponse {
    meaning?: MeaningDto | undefined;

    [key: string]: any;

    constructor(data?: IMeaningCreationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.meaning = _data["meaning"] ? MeaningDto.fromJS(_data["meaning"]) : undefined as any;
        }
    }

    static fromJS(data: any): MeaningCreationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeaningCreationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["meaning"] = this.meaning ? this.meaning.toJSON() : undefined as any;
        return data;
    }
}

export interface IMeaningCreationResponse {
    meaning?: MeaningDto | undefined;

    [key: string]: any;
}

export class MeaningDto implements IMeaningDto {
    id!: string;
    meaning?: MeaningContentDto | undefined;
    tags?: MeaningTagDto[];

    [key: string]: any;

    constructor(data?: IMeaningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.meaning = _data["meaning"] ? MeaningContentDto.fromJS(_data["meaning"]) : undefined as any;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(MeaningTagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeaningDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeaningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["meaning"] = this.meaning ? this.meaning.toJSON() : undefined as any;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMeaningDto {
    id: string;
    meaning?: MeaningContentDto | undefined;
    tags?: MeaningTagDto[];

    [key: string]: any;
}

export enum MeaningKind {
    Card = "Card",
    Note = "Note",
    Manual = "Manual",
}

export class MeaningRequest implements IMeaningRequest {
    text?: string;

    [key: string]: any;

    constructor(data?: IMeaningRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): MeaningRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MeaningRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        return data;
    }
}

export interface IMeaningRequest {
    text?: string;

    [key: string]: any;
}

export class MeaningSuggestionDto implements IMeaningSuggestionDto {
    id!: string;
    displayedText!: string;
    translation!: string | undefined;

    [key: string]: any;

    constructor(data?: IMeaningSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.displayedText = _data["displayedText"];
            this.translation = _data["translation"];
        }
    }

    static fromJS(data: any): MeaningSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeaningSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["displayedText"] = this.displayedText;
        data["translation"] = this.translation;
        return data;
    }
}

export interface IMeaningSuggestionDto {
    id: string;
    displayedText: string;
    translation: string | undefined;

    [key: string]: any;
}

export class MeaningTagDto implements IMeaningTagDto {
    id?: string;
    name?: string;

    [key: string]: any;

    constructor(data?: IMeaningTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MeaningTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeaningTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMeaningTagDto {
    id?: string;
    name?: string;

    [key: string]: any;
}

export class NewsHighlightSpan implements INewsHighlightSpan {
    start!: number;
    end!: number;

    [key: string]: any;

    constructor(data?: INewsHighlightSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): NewsHighlightSpan {
        data = typeof data === 'object' ? data : {};
        let result = new NewsHighlightSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["start"] = this.start;
        data["end"] = this.end;
        return data;
    }
}

export interface INewsHighlightSpan {
    start: number;
    end: number;

    [key: string]: any;
}

export class NewsSearchItemDto implements INewsSearchItemDto {
    sentenceId!: number;
    sentence!: string;
    highlightSpans!: NewsHighlightSpan[];
    articleUrl!: string;
    articleTitle!: string | undefined;
    articleDomain!: string;
    siteName!: string | undefined;
    logoUrl!: string | undefined;
    publishedAtUtc!: Date | undefined;
    createdAtUtc!: Date;

    [key: string]: any;

    constructor(data?: INewsSearchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.highlightSpans = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sentenceId = _data["sentenceId"];
            this.sentence = _data["sentence"];
            if (Array.isArray(_data["highlightSpans"])) {
                this.highlightSpans = [] as any;
                for (let item of _data["highlightSpans"])
                    this.highlightSpans!.push(NewsHighlightSpan.fromJS(item));
            }
            this.articleUrl = _data["articleUrl"];
            this.articleTitle = _data["articleTitle"];
            this.articleDomain = _data["articleDomain"];
            this.siteName = _data["siteName"];
            this.logoUrl = _data["logoUrl"];
            this.publishedAtUtc = _data["publishedAtUtc"] ? new Date(_data["publishedAtUtc"].toString()) : undefined as any;
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): NewsSearchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsSearchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sentenceId"] = this.sentenceId;
        data["sentence"] = this.sentence;
        if (Array.isArray(this.highlightSpans)) {
            data["highlightSpans"] = [];
            for (let item of this.highlightSpans)
                data["highlightSpans"].push(item ? item.toJSON() : undefined as any);
        }
        data["articleUrl"] = this.articleUrl;
        data["articleTitle"] = this.articleTitle;
        data["articleDomain"] = this.articleDomain;
        data["siteName"] = this.siteName;
        data["logoUrl"] = this.logoUrl;
        data["publishedAtUtc"] = this.publishedAtUtc ? this.publishedAtUtc.toISOString() : undefined as any;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface INewsSearchItemDto {
    sentenceId: number;
    sentence: string;
    highlightSpans: NewsHighlightSpan[];
    articleUrl: string;
    articleTitle: string | undefined;
    articleDomain: string;
    siteName: string | undefined;
    logoUrl: string | undefined;
    publishedAtUtc: Date | undefined;
    createdAtUtc: Date;

    [key: string]: any;
}

export class NewsSearchPageResponse implements INewsSearchPageResponse {
    items!: NewsSearchItemDto[];
    nextCursor!: string | undefined;
    hasMore!: boolean;

    [key: string]: any;

    constructor(data?: INewsSearchPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NewsSearchItemDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): NewsSearchPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NewsSearchPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface INewsSearchPageResponse {
    items: NewsSearchItemDto[];
    nextCursor: string | undefined;
    hasMore: boolean;

    [key: string]: any;
}

export class PhraseChipDto implements IPhraseChipDto {
    lemma!: string;
    pos!: string;

    [key: string]: any;

    constructor(data?: IPhraseChipDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lemma = _data["lemma"];
            this.pos = _data["pos"];
        }
    }

    static fromJS(data: any): PhraseChipDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseChipDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lemma"] = this.lemma;
        data["pos"] = this.pos;
        return data;
    }
}

export interface IPhraseChipDto {
    lemma: string;
    pos: string;

    [key: string]: any;
}

export class PhraseTokenDto implements IPhraseTokenDto {
    lemma!: string;
    isStop!: boolean;
    pos!: string;
    dep!: string;
    headIndex!: number;
    phraseIndex!: number;

    [key: string]: any;

    constructor(data?: IPhraseTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lemma = _data["lemma"];
            this.isStop = _data["isStop"];
            this.pos = _data["pos"];
            this.dep = _data["dep"];
            this.headIndex = _data["headIndex"];
            this.phraseIndex = _data["phraseIndex"];
        }
    }

    static fromJS(data: any): PhraseTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhraseTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lemma"] = this.lemma;
        data["isStop"] = this.isStop;
        data["pos"] = this.pos;
        data["dep"] = this.dep;
        data["headIndex"] = this.headIndex;
        data["phraseIndex"] = this.phraseIndex;
        return data;
    }
}

export interface IPhraseTokenDto {
    lemma: string;
    isStop: boolean;
    pos: string;
    dep: string;
    headIndex: number;
    phraseIndex: number;

    [key: string]: any;
}

export class PinMeaningExampleRequest implements IPinMeaningExampleRequest {
    exampleIndex!: number;
    pinned!: boolean;

    [key: string]: any;

    constructor(data?: IPinMeaningExampleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.exampleIndex = _data["exampleIndex"];
            this.pinned = _data["pinned"];
        }
    }

    static fromJS(data: any): PinMeaningExampleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PinMeaningExampleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["exampleIndex"] = this.exampleIndex;
        data["pinned"] = this.pinned;
        return data;
    }
}

export interface IPinMeaningExampleRequest {
    exampleIndex: number;
    pinned: boolean;

    [key: string]: any;
}

export class PinMeaningExampleResponse implements IPinMeaningExampleResponse {
    exampleIndex!: number;
    pinned!: boolean;

    [key: string]: any;

    constructor(data?: IPinMeaningExampleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.exampleIndex = _data["exampleIndex"];
            this.pinned = _data["pinned"];
        }
    }

    static fromJS(data: any): PinMeaningExampleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PinMeaningExampleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["exampleIndex"] = this.exampleIndex;
        data["pinned"] = this.pinned;
        return data;
    }
}

export interface IPinMeaningExampleResponse {
    exampleIndex: number;
    pinned: boolean;

    [key: string]: any;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ReplaceMeaningTagsRequest implements IReplaceMeaningTagsRequest {
    tagIds!: string[] | undefined;
    newTagNames!: string[] | undefined;

    [key: string]: any;

    constructor(data?: IReplaceMeaningTagsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["newTagNames"])) {
                this.newTagNames = [] as any;
                for (let item of _data["newTagNames"])
                    this.newTagNames!.push(item);
            }
        }
    }

    static fromJS(data: any): ReplaceMeaningTagsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReplaceMeaningTagsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.newTagNames)) {
            data["newTagNames"] = [];
            for (let item of this.newTagNames)
                data["newTagNames"].push(item);
        }
        return data;
    }
}

export interface IReplaceMeaningTagsRequest {
    tagIds: string[] | undefined;
    newTagNames: string[] | undefined;

    [key: string]: any;
}

export class SelectionRange implements ISelectionRange {
    start?: number;
    length?: number;

    [key: string]: any;

    constructor(data?: ISelectionRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.start = _data["start"];
            this.length = _data["length"];
        }
    }

    static fromJS(data: any): SelectionRange {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["start"] = this.start;
        data["length"] = this.length;
        return data;
    }
}

export interface ISelectionRange {
    start?: number;
    length?: number;

    [key: string]: any;
}

export class SseItemOfCardChatEvent implements ISseItemOfCardChatEvent {
    data?: CardChatEvent;
    eventType?: string | undefined;
    eventId?: string | undefined;
    reconnectionInterval?: string | undefined;

    [key: string]: any;

    constructor(data?: ISseItemOfCardChatEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["data"] ? CardChatEvent.fromJS(_data["data"]) : undefined as any;
            this.eventType = _data["eventType"];
            this.eventId = _data["eventId"];
            this.reconnectionInterval = _data["reconnectionInterval"];
        }
    }

    static fromJS(data: any): SseItemOfCardChatEvent {
        data = typeof data === 'object' ? data : {};
        let result = new SseItemOfCardChatEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["eventType"] = this.eventType;
        data["eventId"] = this.eventId;
        data["reconnectionInterval"] = this.reconnectionInterval;
        return data;
    }
}

export interface ISseItemOfCardChatEvent {
    data?: CardChatEvent;
    eventType?: string | undefined;
    eventId?: string | undefined;
    reconnectionInterval?: string | undefined;

    [key: string]: any;
}

export class SupportedLanguage implements ISupportedLanguage {
    code!: string;
    name!: string;

    [key: string]: any;

    constructor(data?: ISupportedLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SupportedLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new SupportedLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface ISupportedLanguage {
    code: string;
    name: string;

    [key: string]: any;
}

export class TagStatisticsItemResponse implements ITagStatisticsItemResponse {
    id!: string;
    name!: string;
    cardCount!: number;

    [key: string]: any;

    constructor(data?: ITagStatisticsItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.cardCount = _data["cardCount"];
        }
    }

    static fromJS(data: any): TagStatisticsItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagStatisticsItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["cardCount"] = this.cardCount;
        return data;
    }
}

export interface ITagStatisticsItemResponse {
    id: string;
    name: string;
    cardCount: number;

    [key: string]: any;
}

export class TagStatisticsResponse implements ITagStatisticsResponse {
    totalCardCount!: number;
    totalTagCount!: number;
    tags!: TagStatisticsItemResponse[];

    [key: string]: any;

    constructor(data?: ITagStatisticsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.totalCardCount = _data["totalCardCount"];
            this.totalTagCount = _data["totalTagCount"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagStatisticsItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagStatisticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TagStatisticsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["totalCardCount"] = this.totalCardCount;
        data["totalTagCount"] = this.totalTagCount;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITagStatisticsResponse {
    totalCardCount: number;
    totalTagCount: number;
    tags: TagStatisticsItemResponse[];

    [key: string]: any;
}

export class TrainingCardResponse implements ITrainingCardResponse {
    cardId!: string;
    meaning!: TrainingMeaningResponse | undefined;
    training!: TrainingCardStateResponse;

    [key: string]: any;

    constructor(data?: ITrainingCardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.training = new TrainingCardStateResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cardId = _data["cardId"];
            this.meaning = _data["meaning"] ? TrainingMeaningResponse.fromJS(_data["meaning"]) : undefined as any;
            this.training = _data["training"] ? TrainingCardStateResponse.fromJS(_data["training"]) : new TrainingCardStateResponse();
        }
    }

    static fromJS(data: any): TrainingCardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cardId"] = this.cardId;
        data["meaning"] = this.meaning ? this.meaning.toJSON() : undefined as any;
        data["training"] = this.training ? this.training.toJSON() : undefined as any;
        return data;
    }
}

export interface ITrainingCardResponse {
    cardId: string;
    meaning: TrainingMeaningResponse | undefined;
    training: TrainingCardStateResponse;

    [key: string]: any;
}

export class TrainingCardsResponse implements ITrainingCardsResponse {
    cards!: TrainingCardResponse[];
    ratingOptions!: string[];
    dueCount!: number;

    [key: string]: any;

    constructor(data?: ITrainingCardsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.cards = [];
            this.ratingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["cards"])) {
                this.cards = [] as any;
                for (let item of _data["cards"])
                    this.cards!.push(TrainingCardResponse.fromJS(item));
            }
            if (Array.isArray(_data["ratingOptions"])) {
                this.ratingOptions = [] as any;
                for (let item of _data["ratingOptions"])
                    this.ratingOptions!.push(item);
            }
            this.dueCount = _data["dueCount"];
        }
    }

    static fromJS(data: any): TrainingCardsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCardsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.cards)) {
            data["cards"] = [];
            for (let item of this.cards)
                data["cards"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ratingOptions)) {
            data["ratingOptions"] = [];
            for (let item of this.ratingOptions)
                data["ratingOptions"].push(item);
        }
        data["dueCount"] = this.dueCount;
        return data;
    }
}

export interface ITrainingCardsResponse {
    cards: TrainingCardResponse[];
    ratingOptions: string[];
    dueCount: number;

    [key: string]: any;
}

export class TrainingCardStateResponse implements ITrainingCardStateResponse {
    lastTrainedAt!: Date | undefined;
    nextTrainAt!: Date;
    consecutiveCorrect!: number;
    reviewHistory!: TrainingReviewLogResponse[];
    intervalPreviews!: TrainingIntervalPreviewResponse[];

    [key: string]: any;

    constructor(data?: ITrainingCardStateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.reviewHistory = [];
            this.intervalPreviews = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lastTrainedAt = _data["lastTrainedAt"] ? new Date(_data["lastTrainedAt"].toString()) : undefined as any;
            this.nextTrainAt = _data["nextTrainAt"] ? new Date(_data["nextTrainAt"].toString()) : undefined as any;
            this.consecutiveCorrect = _data["consecutiveCorrect"];
            if (Array.isArray(_data["reviewHistory"])) {
                this.reviewHistory = [] as any;
                for (let item of _data["reviewHistory"])
                    this.reviewHistory!.push(TrainingReviewLogResponse.fromJS(item));
            }
            if (Array.isArray(_data["intervalPreviews"])) {
                this.intervalPreviews = [] as any;
                for (let item of _data["intervalPreviews"])
                    this.intervalPreviews!.push(TrainingIntervalPreviewResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingCardStateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCardStateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lastTrainedAt"] = this.lastTrainedAt ? this.lastTrainedAt.toISOString() : undefined as any;
        data["nextTrainAt"] = this.nextTrainAt ? this.nextTrainAt.toISOString() : undefined as any;
        data["consecutiveCorrect"] = this.consecutiveCorrect;
        if (Array.isArray(this.reviewHistory)) {
            data["reviewHistory"] = [];
            for (let item of this.reviewHistory)
                data["reviewHistory"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.intervalPreviews)) {
            data["intervalPreviews"] = [];
            for (let item of this.intervalPreviews)
                data["intervalPreviews"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrainingCardStateResponse {
    lastTrainedAt: Date | undefined;
    nextTrainAt: Date;
    consecutiveCorrect: number;
    reviewHistory: TrainingReviewLogResponse[];
    intervalPreviews: TrainingIntervalPreviewResponse[];

    [key: string]: any;
}

export class TrainingIntervalPreviewResponse implements ITrainingIntervalPreviewResponse {
    rating!: string;
    intervalHours!: number;

    [key: string]: any;

    constructor(data?: ITrainingIntervalPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.rating = _data["rating"];
            this.intervalHours = _data["intervalHours"];
        }
    }

    static fromJS(data: any): TrainingIntervalPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingIntervalPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["rating"] = this.rating;
        data["intervalHours"] = this.intervalHours;
        return data;
    }
}

export interface ITrainingIntervalPreviewResponse {
    rating: string;
    intervalHours: number;

    [key: string]: any;
}

export class TrainingMeaningResponse implements ITrainingMeaningResponse {
    kind!: string;
    canonical!: string | undefined;
    displayedText!: string | undefined;
    sound!: string | undefined;
    origin!: TrainingOriginResponse;
    phraseChips!: PhraseChipDto[];
    definition!: string | undefined;
    translations!: string[];
    alternatives!: MeaningAlternativeDto[];
    examples!: ExampleDto[];

    [key: string]: any;

    constructor(data?: ITrainingMeaningResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.origin = new TrainingOriginResponse();
            this.phraseChips = [];
            this.translations = [];
            this.alternatives = [];
            this.examples = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.kind = _data["kind"];
            this.canonical = _data["canonical"];
            this.displayedText = _data["displayedText"];
            this.sound = _data["sound"];
            this.origin = _data["origin"] ? TrainingOriginResponse.fromJS(_data["origin"]) : new TrainingOriginResponse();
            if (Array.isArray(_data["phraseChips"])) {
                this.phraseChips = [] as any;
                for (let item of _data["phraseChips"])
                    this.phraseChips!.push(PhraseChipDto.fromJS(item));
            }
            this.definition = _data["definition"];
            if (Array.isArray(_data["translations"])) {
                this.translations = [] as any;
                for (let item of _data["translations"])
                    this.translations!.push(item);
            }
            if (Array.isArray(_data["alternatives"])) {
                this.alternatives = [] as any;
                for (let item of _data["alternatives"])
                    this.alternatives!.push(MeaningAlternativeDto.fromJS(item));
            }
            if (Array.isArray(_data["examples"])) {
                this.examples = [] as any;
                for (let item of _data["examples"])
                    this.examples!.push(ExampleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingMeaningResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingMeaningResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["kind"] = this.kind;
        data["canonical"] = this.canonical;
        data["displayedText"] = this.displayedText;
        data["sound"] = this.sound;
        data["origin"] = this.origin ? this.origin.toJSON() : undefined as any;
        if (Array.isArray(this.phraseChips)) {
            data["phraseChips"] = [];
            for (let item of this.phraseChips)
                data["phraseChips"].push(item ? item.toJSON() : undefined as any);
        }
        data["definition"] = this.definition;
        if (Array.isArray(this.translations)) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item);
        }
        if (Array.isArray(this.alternatives)) {
            data["alternatives"] = [];
            for (let item of this.alternatives)
                data["alternatives"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.examples)) {
            data["examples"] = [];
            for (let item of this.examples)
                data["examples"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrainingMeaningResponse {
    kind: string;
    canonical: string | undefined;
    displayedText: string | undefined;
    sound: string | undefined;
    origin: TrainingOriginResponse;
    phraseChips: PhraseChipDto[];
    definition: string | undefined;
    translations: string[];
    alternatives: MeaningAlternativeDto[];
    examples: ExampleDto[];

    [key: string]: any;
}

export class TrainingOriginResponse implements ITrainingOriginResponse {
    text!: string;
    selections!: SelectionRange[];

    [key: string]: any;

    constructor(data?: ITrainingOriginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.selections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [] as any;
                for (let item of _data["selections"])
                    this.selections!.push(SelectionRange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingOriginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingOriginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITrainingOriginResponse {
    text: string;
    selections: SelectionRange[];

    [key: string]: any;
}

export class TrainingReviewLogResponse implements ITrainingReviewLogResponse {
    rating!: string;
    reviewedAt!: Date;

    [key: string]: any;

    constructor(data?: ITrainingReviewLogResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.rating = _data["rating"];
            this.reviewedAt = _data["reviewedAt"] ? new Date(_data["reviewedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TrainingReviewLogResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingReviewLogResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["rating"] = this.rating;
        data["reviewedAt"] = this.reviewedAt ? this.reviewedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ITrainingReviewLogResponse {
    rating: string;
    reviewedAt: Date;

    [key: string]: any;
}

export class TrainingReviewRequest implements ITrainingReviewRequest {
    rating!: string;

    [key: string]: any;

    constructor(data?: ITrainingReviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.rating = _data["rating"];
        }
    }

    static fromJS(data: any): TrainingReviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingReviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["rating"] = this.rating;
        return data;
    }
}

export interface ITrainingReviewRequest {
    rating: string;

    [key: string]: any;
}

export class UpdateUserSettingsRequest implements IUpdateUserSettingsRequest {
    nativeLanguage?: string | undefined;
    learningLanguage?: string | undefined;
    useSlottedForm?: boolean | undefined;

    [key: string]: any;

    constructor(data?: IUpdateUserSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nativeLanguage = _data["nativeLanguage"];
            this.learningLanguage = _data["learningLanguage"];
            this.useSlottedForm = _data["useSlottedForm"];
        }
    }

    static fromJS(data: any): UpdateUserSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nativeLanguage"] = this.nativeLanguage;
        data["learningLanguage"] = this.learningLanguage;
        data["useSlottedForm"] = this.useSlottedForm;
        return data;
    }
}

export interface IUpdateUserSettingsRequest {
    nativeLanguage?: string | undefined;
    learningLanguage?: string | undefined;
    useSlottedForm?: boolean | undefined;

    [key: string]: any;
}

export class UserAccountResponse implements IUserAccountResponse {
    id?: string;
    email?: string | undefined;
    name?: string | undefined;
    pictureUrl?: string | undefined;
    nativeLanguage?: string | undefined;
    learningLanguage?: string | undefined;
    useSlottedForm?: boolean;
    onboardingCompleted?: boolean;

    [key: string]: any;

    constructor(data?: IUserAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.pictureUrl = _data["pictureUrl"];
            this.nativeLanguage = _data["nativeLanguage"];
            this.learningLanguage = _data["learningLanguage"];
            this.useSlottedForm = _data["useSlottedForm"];
            this.onboardingCompleted = _data["onboardingCompleted"];
        }
    }

    static fromJS(data: any): UserAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["pictureUrl"] = this.pictureUrl;
        data["nativeLanguage"] = this.nativeLanguage;
        data["learningLanguage"] = this.learningLanguage;
        data["useSlottedForm"] = this.useSlottedForm;
        data["onboardingCompleted"] = this.onboardingCompleted;
        return data;
    }
}

export interface IUserAccountResponse {
    id?: string;
    email?: string | undefined;
    name?: string | undefined;
    pictureUrl?: string | undefined;
    nativeLanguage?: string | undefined;
    learningLanguage?: string | undefined;
    useSlottedForm?: boolean;
    onboardingCompleted?: boolean;

    [key: string]: any;
}

export class VideoTextSearchRequest implements IVideoTextSearchRequest {
    query?: string | undefined;
    limit?: number;
    cursor?: string | undefined;

    [key: string]: any;

    constructor(data?: IVideoTextSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.query = _data["query"];
            this.limit = _data["limit"];
            this.cursor = _data["cursor"];
        }
    }

    static fromJS(data: any): VideoTextSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VideoTextSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["query"] = this.query;
        data["limit"] = this.limit;
        data["cursor"] = this.cursor;
        return data;
    }
}

export interface IVideoTextSearchRequest {
    query?: string | undefined;
    limit?: number;
    cursor?: string | undefined;

    [key: string]: any;
}

export class WeeklyStatisticsResponse implements IWeeklyStatisticsResponse {
    weekStartDate!: Date;
    newCardsCount!: number;
    reviewsCount!: number;
    accuracyPercentage!: number;
    dailyNewCards!: DailyNewCardsResponse[];

    [key: string]: any;

    constructor(data?: IWeeklyStatisticsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dailyNewCards = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.weekStartDate = _data["weekStartDate"] ? new Date(_data["weekStartDate"].toString()) : undefined as any;
            this.newCardsCount = _data["newCardsCount"];
            this.reviewsCount = _data["reviewsCount"];
            this.accuracyPercentage = _data["accuracyPercentage"];
            if (Array.isArray(_data["dailyNewCards"])) {
                this.dailyNewCards = [] as any;
                for (let item of _data["dailyNewCards"])
                    this.dailyNewCards!.push(DailyNewCardsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeeklyStatisticsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyStatisticsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["weekStartDate"] = this.weekStartDate ? formatDate(this.weekStartDate) : undefined as any;
        data["newCardsCount"] = this.newCardsCount;
        data["reviewsCount"] = this.reviewsCount;
        data["accuracyPercentage"] = this.accuracyPercentage;
        if (Array.isArray(this.dailyNewCards)) {
            data["dailyNewCards"] = [];
            for (let item of this.dailyNewCards)
                data["dailyNewCards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWeeklyStatisticsResponse {
    weekStartDate: Date;
    newCardsCount: number;
    reviewsCount: number;
    accuracyPercentage: number;
    dailyNewCards: DailyNewCardsResponse[];

    [key: string]: any;
}

export class YoutubeCaptionItemDto implements IYoutubeCaptionItemDto {
    sentenceId!: number;
    text!: string;
    startMilliseconds!: number;
    endMilliseconds!: number;
    cues!: YoutubeCueDto[];

    [key: string]: any;

    constructor(data?: IYoutubeCaptionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.cues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sentenceId = _data["sentenceId"];
            this.text = _data["text"];
            this.startMilliseconds = _data["startMilliseconds"];
            this.endMilliseconds = _data["endMilliseconds"];
            if (Array.isArray(_data["cues"])) {
                this.cues = [] as any;
                for (let item of _data["cues"])
                    this.cues!.push(YoutubeCueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): YoutubeCaptionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeCaptionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sentenceId"] = this.sentenceId;
        data["text"] = this.text;
        data["startMilliseconds"] = this.startMilliseconds;
        data["endMilliseconds"] = this.endMilliseconds;
        if (Array.isArray(this.cues)) {
            data["cues"] = [];
            for (let item of this.cues)
                data["cues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IYoutubeCaptionItemDto {
    sentenceId: number;
    text: string;
    startMilliseconds: number;
    endMilliseconds: number;
    cues: YoutubeCueDto[];

    [key: string]: any;
}

export class YoutubeCaptionJobClaimResponse implements IYoutubeCaptionJobClaimResponse {
    jobId!: number;
    videoId!: string;
    leaseId!: string;

    [key: string]: any;

    constructor(data?: IYoutubeCaptionJobClaimResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.jobId = _data["jobId"];
            this.videoId = _data["videoId"];
            this.leaseId = _data["leaseId"];
        }
    }

    static fromJS(data: any): YoutubeCaptionJobClaimResponse {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeCaptionJobClaimResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["jobId"] = this.jobId;
        data["videoId"] = this.videoId;
        data["leaseId"] = this.leaseId;
        return data;
    }
}

export interface IYoutubeCaptionJobClaimResponse {
    jobId: number;
    videoId: string;
    leaseId: string;

    [key: string]: any;
}

export class YoutubeCaptionJobCompleteRequest implements IYoutubeCaptionJobCompleteRequest {
    leaseId!: string;
    languageCode!: string | undefined;
    isGenerated!: boolean;
    srt!: string | undefined;

    [key: string]: any;

    constructor(data?: IYoutubeCaptionJobCompleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.leaseId = _data["leaseId"];
            this.languageCode = _data["languageCode"];
            this.isGenerated = _data["isGenerated"];
            this.srt = _data["srt"];
        }
    }

    static fromJS(data: any): YoutubeCaptionJobCompleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeCaptionJobCompleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["leaseId"] = this.leaseId;
        data["languageCode"] = this.languageCode;
        data["isGenerated"] = this.isGenerated;
        data["srt"] = this.srt;
        return data;
    }
}

export interface IYoutubeCaptionJobCompleteRequest {
    leaseId: string;
    languageCode: string | undefined;
    isGenerated: boolean;
    srt: string | undefined;

    [key: string]: any;
}

export class YoutubeCaptionJobFailureRequest implements IYoutubeCaptionJobFailureRequest {
    leaseId!: string;
    kind!: string | undefined;
    error!: string | undefined;

    [key: string]: any;

    constructor(data?: IYoutubeCaptionJobFailureRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.leaseId = _data["leaseId"];
            this.kind = _data["kind"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): YoutubeCaptionJobFailureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeCaptionJobFailureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["leaseId"] = this.leaseId;
        data["kind"] = this.kind;
        data["error"] = this.error;
        return data;
    }
}

export interface IYoutubeCaptionJobFailureRequest {
    leaseId: string;
    kind: string | undefined;
    error: string | undefined;

    [key: string]: any;
}

export class YoutubeCaptionTrackResponse implements IYoutubeCaptionTrackResponse {
    videoId!: string;
    captions!: YoutubeCaptionItemDto[];

    [key: string]: any;

    constructor(data?: IYoutubeCaptionTrackResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.captions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.videoId = _data["videoId"];
            if (Array.isArray(_data["captions"])) {
                this.captions = [] as any;
                for (let item of _data["captions"])
                    this.captions!.push(YoutubeCaptionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): YoutubeCaptionTrackResponse {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeCaptionTrackResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["videoId"] = this.videoId;
        if (Array.isArray(this.captions)) {
            data["captions"] = [];
            for (let item of this.captions)
                data["captions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IYoutubeCaptionTrackResponse {
    videoId: string;
    captions: YoutubeCaptionItemDto[];

    [key: string]: any;
}

export class YoutubeCueDto implements IYoutubeCueDto {
    text!: string;
    startMilliseconds!: number;
    endMilliseconds!: number;
    startChar!: number;

    [key: string]: any;

    constructor(data?: IYoutubeCueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            this.startMilliseconds = _data["startMilliseconds"];
            this.endMilliseconds = _data["endMilliseconds"];
            this.startChar = _data["startChar"];
        }
    }

    static fromJS(data: any): YoutubeCueDto {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeCueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        data["startMilliseconds"] = this.startMilliseconds;
        data["endMilliseconds"] = this.endMilliseconds;
        data["startChar"] = this.startChar;
        return data;
    }
}

export interface IYoutubeCueDto {
    text: string;
    startMilliseconds: number;
    endMilliseconds: number;
    startChar: number;

    [key: string]: any;
}

export class YoutubeHighlightSpan implements IYoutubeHighlightSpan {
    start!: number;
    end!: number;

    [key: string]: any;

    constructor(data?: IYoutubeHighlightSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.start = _data["start"];
            this.end = _data["end"];
        }
    }

    static fromJS(data: any): YoutubeHighlightSpan {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeHighlightSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["start"] = this.start;
        data["end"] = this.end;
        return data;
    }
}

export interface IYoutubeHighlightSpan {
    start: number;
    end: number;

    [key: string]: any;
}

export class YoutubeSearchItemDto implements IYoutubeSearchItemDto {
    sentenceId!: number;
    videoId!: string;
    sentence!: string;
    highlightSpans!: YoutubeHighlightSpan[];
    sentenceStartMilliseconds!: number;
    sentenceEndMilliseconds!: number;
    playbackStartMilliseconds!: number;

    [key: string]: any;

    constructor(data?: IYoutubeSearchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.highlightSpans = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sentenceId = _data["sentenceId"];
            this.videoId = _data["videoId"];
            this.sentence = _data["sentence"];
            if (Array.isArray(_data["highlightSpans"])) {
                this.highlightSpans = [] as any;
                for (let item of _data["highlightSpans"])
                    this.highlightSpans!.push(YoutubeHighlightSpan.fromJS(item));
            }
            this.sentenceStartMilliseconds = _data["sentenceStartMilliseconds"];
            this.sentenceEndMilliseconds = _data["sentenceEndMilliseconds"];
            this.playbackStartMilliseconds = _data["playbackStartMilliseconds"];
        }
    }

    static fromJS(data: any): YoutubeSearchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeSearchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sentenceId"] = this.sentenceId;
        data["videoId"] = this.videoId;
        data["sentence"] = this.sentence;
        if (Array.isArray(this.highlightSpans)) {
            data["highlightSpans"] = [];
            for (let item of this.highlightSpans)
                data["highlightSpans"].push(item ? item.toJSON() : undefined as any);
        }
        data["sentenceStartMilliseconds"] = this.sentenceStartMilliseconds;
        data["sentenceEndMilliseconds"] = this.sentenceEndMilliseconds;
        data["playbackStartMilliseconds"] = this.playbackStartMilliseconds;
        return data;
    }
}

export interface IYoutubeSearchItemDto {
    sentenceId: number;
    videoId: string;
    sentence: string;
    highlightSpans: YoutubeHighlightSpan[];
    sentenceStartMilliseconds: number;
    sentenceEndMilliseconds: number;
    playbackStartMilliseconds: number;

    [key: string]: any;
}

export class YoutubeSearchPageResponse implements IYoutubeSearchPageResponse {
    items!: YoutubeSearchItemDto[];
    nextCursor!: string | undefined;
    hasMore!: boolean;

    [key: string]: any;

    constructor(data?: IYoutubeSearchPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(YoutubeSearchItemDto.fromJS(item));
            }
            this.nextCursor = _data["nextCursor"];
            this.hasMore = _data["hasMore"];
        }
    }

    static fromJS(data: any): YoutubeSearchPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new YoutubeSearchPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextCursor"] = this.nextCursor;
        data["hasMore"] = this.hasMore;
        return data;
    }
}

export interface IYoutubeSearchPageResponse {
    items: YoutubeSearchItemDto[];
    nextCursor: string | undefined;
    hasMore: boolean;

    [key: string]: any;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

// NSwag 14.7 references FileParameter for multipart uploads but does not emit it
// for this OpenAPI 3.1 document; remove if a future NSwag generates its own.
export interface FileParameter {
    data: any;
    fileName: string;
}